module.exports = __webpack_public_path__ + "static/media/Mummy.e143d74f.jpg";